import React, { useState } from 'react'
import styles from './JumpFrameStyles'
import { Dropdown } from 'semantic-ui-react'
import Rewind from './Rewind'
import Forward from './Forward'

const defaultJumpSpanValue = 0.25

const frameJumpOptions = [
  {
    key: 'half-of-a-second',
    text: 'Fast',
    value: 0.5
  },
  {
    key: 'quarter-of-a-second',
    text: 'Medium',
    value: defaultJumpSpanValue
  },
  {
    key: 'eighth-of-a-second',
    text: 'Slow',
    value: 0.125
  }
]

export default ({
  onRewindClick, onForwardClick
}) => {
  const [currentJumpSpanValue, setJumpSpanValue] =
      useState(defaultJumpSpanValue)

  return (
    <div className={styles.component}>
      <Rewind onClick={onRewindClick(currentJumpSpanValue)} />
      <Dropdown
        className={styles.jumpSpanSelection}
        onChange={(_, { value }) => setJumpSpanValue(value)}
        defaultValue={defaultJumpSpanValue}
        options={frameJumpOptions}
      />
      <Forward onClick={onForwardClick(currentJumpSpanValue)} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/JumpFrame/JumpFrame.js